import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
  class: "user-selector-add-text"
};
import { ref, computed, watch, h, useAttrs } from 'vue';
import UserTag from './UserTag.vue';
import UserPicker from './UserPicker.vue';
import { useFormDisabled, useFormSize } from 'element-plus';
import { getUser, listUsersByIds } from '@/api/user';
const TAG_DISPLAY_LIMIT = 30;
export default /*@__PURE__*/Object.assign({
  inheritAttrs: false
}, {
  __name: 'index',
  props: {
    modelValue: {
      type: [Number, String, Array],
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择用户'
    },
    maxSelect: {
      type: Number,
      default: null
    },
    excludeIds: {
      type: Array,
      default: () => []
    },
    hideAddButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    // 用户选择图标组件 - 复用项目已有的内联SVG模式
    const UserIcon = {
      props: {
        size: {
          type: Number,
          default: 16
        }
      },
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24',
          style: {
            width: `${this.size}px`,
            height: `${this.size}px`
          }
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7v1h14v-1a7 7 0 00-7-7z'
        })]);
      }
    };
    const $props = __props;
    const $emits = __emit;
    const attrs = useAttrs();

    // 用户信息映射表，用于编辑时根据ID查找用户信息
    const userMap = ref({});
    const normalizeUser = (user, id) => {
      const data = user?.data || user || {};
      return {
        id: data.id ?? id,
        name: data.displayName || data.name || data.username || String(id),
        avatar: data.avatarUrl || data.avatar
      };
    };
    const chunkIds = (arr, size) => {
      const chunks = [];
      for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
      }
      return chunks;
    };

    // 加载用户信息到映射表（优先批量接口，失败时降级为逐个加载）
    const loadUserInfo = async ids => {
      if (!ids || ids.length === 0) return;
      const missingIds = ids.filter(id => id && typeof id !== 'object' && !userMap.value[id]);
      if (missingIds.length === 0) return;
      try {
        const responses = await Promise.all(chunkIds(missingIds, 500).map(chunk => listUsersByIds(chunk)));
        responses.flat().filter(Boolean).forEach(user => {
          const normalized = normalizeUser(user);
          if (normalized.id !== null && normalized.id !== undefined) {
            userMap.value[normalized.id] = normalized;
          }
        });
      } catch (error) {
        console.error('批量加载用户信息失败，降级为逐个加载:', error);
        const users = await Promise.all(missingIds.map(async id => {
          try {
            return normalizeUser(await getUser(id), id);
          } catch (e) {
            console.error('加载用户信息失败:', e);
            return {
              id,
              name: String(id),
              avatar: ''
            };
          }
        }));
        users.forEach(user => {
          userMap.value[user.id] = user;
        });
      }
    };

    // 监听modelValue变化，加载用户信息
    watch(() => $props.modelValue, val => {
      if (!val) return;
      const ids = Array.isArray(val) ? val : [val];
      // 如果有纯ID需要查找用户信息
      const needLoad = ids.some(id => typeof id === 'number' && !userMap.value[id]);
      if (needLoad) {
        loadUserInfo(ids);
      }
    }, {
      immediate: true
    });
    const valueArr = computed(() => {
      if (!$props.modelValue) return [];
      const arr = Array.isArray($props.modelValue) ? $props.modelValue : [$props.modelValue];
      return arr.map(item => {
        if (typeof item === 'object') {
          return item;
        }
        // 纯ID时尝试从映射表获取信息
        return userMap.value[item] || {
          id: item,
          name: '',
          avatar: ''
        };
      });
    });
    // 大量选中时折叠展示，避免渲染上千个标签导致卡顿
    const displayedValueArr = computed(() => valueArr.value.slice(0, TAG_DISPLAY_LIMIT));
    const hiddenValueArr = computed(() => valueArr.value.slice(TAG_DISPLAY_LIMIT));
    const hiddenValueNames = computed(() => {
      const names = hiddenValueArr.value.map(item => typeof item === 'object' ? item.name || item.id : item).filter(Boolean);
      const text = names.slice(0, 50).join('、');
      return names.length > 50 ? `${text}…` : text;
    });
    const userPickerRef = ref();
    const formDisabled = useFormDisabled();
    const formSize = useFormSize();
    const disabled = computed(() => {
      return formDisabled.value || $props.disabled;
    });
    const sizeName = computed(() => {
      const s = formSize.value || 'default';
      if (s === 'small') return 'small';
      if (s === 'large') return 'large';
      return 'default';
    });
    const isEmpty = computed(() => {
      if (!$props.modelValue) return true;
      return Array.isArray($props.modelValue) && $props.modelValue.length === 0;
    });
    const clickable = computed(() => !disabled.value && !$props.hideAddButton);
    const openUserPicker = () => {
      if (!clickable.value) return;
      userPickerRef.value?.open();
    };
    const onPickerConfirm = selectedUsers => {
      selectedUsers.forEach(user => {
        if (user.id) {
          userMap.value[user.id] = {
            id: user.id,
            name: user.name || '',
            avatar: user.avatar || ''
          };
        }
      });
      $emits('confirm', selectedUsers);
    };
    const onClose = id => {
      if (!$props.modelValue) return;
      if ($props.multiple && Array.isArray($props.modelValue)) {
        const newValue = $props.modelValue.filter(item => {
          const itemId = typeof item === 'object' ? item.id : item;
          return String(itemId) !== String(id);
        });
        $emits('update:modelValue', newValue);
      } else {
        $emits('update:modelValue', null);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(UserPicker, {
        ref_key: "userPickerRef",
        ref: userPickerRef,
        multiple: __props.multiple,
        "model-value": __props.modelValue,
        "max-select": __props.maxSelect,
        "exclude-ids": __props.excludeIds,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event)),
        onConfirm: onPickerConfirm
      }, null, 8, ["multiple", "model-value", "max-select", "exclude-ids"]), _createElementVNode("div", _mergeProps(_unref(attrs), {
        class: ["user-selector", {
          'is-disabled': disabled.value,
          'is-empty': isEmpty.value,
          'is-clickable': clickable.value
        }],
        onClick: openUserPicker
      }), [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedValueArr.value, item => {
        return _openBlock(), _createBlock(UserTag, {
          closable: !disabled.value,
          disabled: disabled.value,
          key: typeof item === 'object' ? item.id : item,
          id: typeof item === 'object' ? item.id : item,
          name: typeof item === 'object' ? item.name : '',
          avatar: typeof item === 'object' ? item.avatar : '',
          onClose: $event => onClose(typeof item === 'object' ? item.id : item)
        }, null, 8, ["closable", "disabled", "id", "name", "avatar", "onClose"]);
      }), 128)), hiddenValueArr.value.length > 0 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "user-selector-more",
        title: hiddenValueNames.value
      }, "+" + _toDisplayString(hiddenValueArr.value.length), 9, _hoisted_1)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("span", {
        class: "user-selector-placeholder"
      }, _toDisplayString(__props.placeholder), 513), [[_vShow, isEmpty.value]]), !__props.hideAddButton && !disabled.value ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: _normalizeClass(["user-selector-add", `is-${sizeName.value}`]),
        onClick: _withModifiers(openUserPicker, ["stop"])
      }, [_createVNode(UserIcon, {
        size: sizeName.value === 'small' ? 12 : 14
      }, null, 8, ["size"]), _createElementVNode("span", _hoisted_2, _toDisplayString(isEmpty.value ? '选择' : ''), 1)], 2)) : _createCommentVNode("", true)], 16)], 64);
    };
  }
});